import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Ad from 'react-google-publisher-tag';
import ErrorBoundary from '../../shared/error-boundary';

export default function MREC(props) {
  const { ads, classNames } = props;
  const [showTitle, setShowTitle] = useState(0);

  return (
    <ErrorBoundary>
      {!!_.get(ads, 'path') && (
        <div className={classNames}>
          <div className={`title ${showTitle ? 'show' : 'hide'}`}>Advertisement</div>
          <Ad
            {...ads}
            onImpressionViewable={() => setShowTitle(true)}
            collapseEmpty
            enableSingleRequest
          />
        </div>
      )}
    </ErrorBoundary>
  );
}

MREC.propTypes = {
  ads: PropTypes.shape({
    path: PropTypes.string,
  }),
  classNames: PropTypes.string.isRequired,
};

MREC.defaultProps = {
  ads: null,
};
